import { render, staticRenderFns } from "./SearchSupplier.vue?vue&type=template&id=1528088c"
import script from "./SearchSupplier.vue?vue&type=script&lang=js"
export * from "./SearchSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports